import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="treewalker" id="treewalker"></a>
    <h1 {...{
      "id": "windowtreewalker"
    }}>{`window.TreeWalker`}</h1>
    <p>{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker"
      }}>{`WebAPIs - TreeWalker`}</a>{`  `}</p>
    <a name="treewalker-root" id="treewalker-root"></a>
    <h2 {...{
      "id": "root--node"
    }}>{`root : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-root"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-root`}</a>{`  `}</p>
    <a name="treewalker-whattoshow" id="treewalker-whattoshow"></a>
    <h2 {...{
      "id": "whattoshow--number"
    }}>{`whatToShow : `}<inlineCode parentName="h2">{`Number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-whattoshow"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-whattoshow`}</a>{`  `}</p>
    <a name="treewalker-filter" id="treewalker-filter"></a>
    <h2 {...{
      "id": "filter--nodefilter"
    }}>{`filter : `}<inlineCode parentName="h2">{`NodeFilter`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-filter"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-filter`}</a>{`  `}</p>
    <a name="treewalker-parentnode" id="treewalker-parentnode"></a>
    <h2 {...{
      "id": "parentnode"
    }}>{`parentNode()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-parentnode"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-parentnode`}</a>{`  `}</p>
    <a name="treewalker-firstchild" id="treewalker-firstchild"></a>
    <h2 {...{
      "id": "firstchild"
    }}>{`firstChild()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-firstchild"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-firstchild`}</a>{`  `}</p>
    <a name="treewalker-lastchild" id="treewalker-lastchild"></a>
    <h2 {...{
      "id": "lastchild"
    }}>{`lastChild()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-lastchild"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-lastchild`}</a>{`  `}</p>
    <a name="treewalker-previoussibling" id="treewalker-previoussibling"></a>
    <h2 {...{
      "id": "previoussibling"
    }}>{`previousSibling()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-node-previoussibling"
      }}>{`https://dom.spec.whatwg.org/#dom-node-previoussibling`}</a>{`  `}</p>
    <a name="treewalker-nextsibling" id="treewalker-nextsibling"></a>
    <h2 {...{
      "id": "nextsibling"
    }}>{`nextSibling()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-nextsibling"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-nextsibling`}</a>{`  `}</p>
    <a name="treewalker-previousnode" id="treewalker-previousnode"></a>
    <h2 {...{
      "id": "previousnode"
    }}>{`previousNode()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-previousnode"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-previousnode`}</a>{`  `}</p>
    <a name="treewalker-nextnode" id="treewalker-nextnode"></a>
    <h2 {...{
      "id": "nextnode"
    }}>{`nextNode()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://dom.spec.whatwg.org/#dom-treewalker-nextnode"
      }}>{`https://dom.spec.whatwg.org/#dom-treewalker-nextnode`}</a>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      